// Theme.ts

export type Theme = {
  background: string;
  color: string;
  backgroundOpacity: string;
  playerCardBackground: string;
  borderColor: string;
  playerColor: string;
  NumberColor: string;
  playerDataBorder: string;
  playerDataTextColor: string;
  playerDataValueColor: string;
  systemFitBackground: string;
  systemFitBorder: string;
  systemFitDataColor: string;
  tabBorderColor: string;
  tabTitleColor: string;
  playerContentBackground: string;
  secondaryButtonBorderColor: string;
  secondaryButtonBackground: string;
  boxShadow: string;
  dropdownBorderColor: string;
  disciplineTextColor: string;
  filterdropdownBackground: string;
  filterdropdownBorder: string;
  ctaIconsColor: string;
  blurBackground: string;
  selectedListBackground: string;
  // Add other theme properties as needed

  //Pitch Options
  PitchColor: string;
  injuryBarColor: string;
  playerCardBorderColor: string;
  scrollbarTrack: string;
  scrollbarThumb: string;
  notificationBackground: string;
  thumbBackground: string;
  thumbHoverBackground: string;
  notificationTextColor: string;
  notificationTitleColor: string;
  playerHeaderBackground: string;
  chemistryPitchFill: string;
  clubInfoValue: string;
  searchResultsFooterBackground: string;
  swapOutIconBorder: string;
  swapOutIconBackground: string;
  swapSamePositionPlayerBorder: string;
  newSearchBar: string;
  matchLabel: string;
  middlePitchInfoRect: string;
  timeline: string;
  playerPositionLabel: string;
  criteriabackground: string;
  emptyDataBorder: string;
  mode: "light" | "dark";
  cardShadow: string;
  imageBorderColor: string;
  buttonBorderColor: string;
  tableDateColor: string;
  graphAreaColor: string;
  areaLineColor: string;
  summarybarOpenColor: string;
  expanderColor : string;
  shade2Chart: string;
  shade1ChartHover: string;
  shade2ChartHover: string;
  alteredTextColor: string;
};

export const lightTheme: Theme = {
  background: 'var(--light-background)',
  color: 'var(--light-text)',
  backgroundOpacity: 'var(--light-background-opacity)',
  playerCardBackground: 'var(--Warm-Grey-warm-grey-200, #F2F5EE)',
  borderColor: 'var(--Warm-Grey-warm-grey-400, #C2C2C2)',
  playerColor: 'var(--Brand-black-500, #111)',
  NumberColor: 'var(--Warm-Grey-warm-grey-600, #7C7D79)',
  playerDataBorder: 'var(--Warm-Grey-warm-grey-300, #DADADA)',
  playerDataTextColor: 'var(--Brand-black-500, #111)',
  playerDataValueColor: 'var(--Brand-black-500, #111)',
  systemFitBackground: 'var(--Brand-green-2-500, #4AF075)',
  systemFitBorder: 'none',
  systemFitDataColor: 'var(--Brand-black-500, #111)',
  tabBorderColor: 'var(--Warm-Grey-warm-grey-400, #C2C2C2)',
  tabTitleColor: 'var(--Warm-Grey-warm-grey-500, #A2A4A1)',
  playerContentBackground: 'var(--Warm-Grey-warm-grey-100, #F9FAF7)',
  secondaryButtonBorderColor: 'var(--Warm-Grey-warm-grey-300, #DADADA)',
  secondaryButtonBackground: 'var(--Brand-white-500, #FFF)',
  boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.15)',
  dropdownBorderColor: 'var(--Warm-Grey-warm-grey-200, #F2F5EE)',
  disciplineTextColor: 'var(--Warm-Grey-warm-grey-500, #A2A4A1)',
  filterdropdownBackground: 'var(--Warm-Grey-warm-grey-200, #F2F5EE)',
  filterdropdownBorder: 'var(--Warm-Grey-warm-grey-300, #DADADA)',
  ctaIconsColor: 'var(--Cool-Grey-cool-grey-500, #141414)',
  blurBackground: 'rgba(242, 245, 238, 0.50)',
  selectedListBackground: 'var(--Warm-Grey-warm-grey-100, #F9FAF7)',
  PitchColor: '#F9FAF7',
  injuryBarColor: "#F2F5EE",
  playerCardBorderColor: 'var(--Warm-Grey-warm-grey-400, #C2C2C2)',
  scrollbarTrack: '#F9FAF7',
  scrollbarThumb: 'rgba(17, 17, 17, 0.05)',
  notificationBackground: 'rgba(17, 17, 17, 0.75)',
  thumbBackground: 'var(--Brand-white-500, #FFF)',
  thumbHoverBackground: 'var(--Cool-Grey-cool-grey-100, #D9D9D9)',
  notificationTextColor: 'var(--Warm-Grey-warm-grey-500, #A2A4A1)',
  notificationTitleColor: 'var(--Brand-white-500, #FFF)',
  playerHeaderBackground: 'rgba(242, 245, 238, 1.75)',
  chemistryPitchFill: '#F2F5EE',
  clubInfoValue: 'var(--Brand-black-500, #111)',
  searchResultsFooterBackground: 'rgba(242, 245, 238, 0.50)',
  swapOutIconBorder: "#DADADA",
  swapOutIconBackground: "#F9FAF7",
  swapSamePositionPlayerBorder: "#DADADA",
  newSearchBar: "transparent",
  matchLabel: "#7C7D79",
  playerPositionLabel: "var(--Warm-Grey-warm-grey-600, #7C7D79)",
  middlePitchInfoRect: "rgba(255, 255, 255, 0.75)",
  timeline: "var(--Warm-Grey-warm-grey-300, #DADADA)",
  criteriabackground: "var(--Warm-Grey-warm-grey-100, #F9FAF7",
  emptyDataBorder: 'var(--Warm-Grey-warm-grey-400, #C2C2C2)',
  mode: "light",
  cardShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.15)',
  imageBorderColor: '#7C7D79',
  buttonBorderColor: 'var(--Brand-white-500, #FFF)',
  tableDateColor:'var(--Brand-green-1-500, #00D1A8)',
  graphAreaColor:'var(--Shades-UI-Blue-blue-100, #B0E2F7)',
  areaLineColor:'#8AD4F3',
  summarybarOpenColor: '#F2F5EE',
  expanderColor : '#FFF',
  shade2Chart : "#F9FAF7",
  shade1ChartHover: "#EDF0EA",
  shade2ChartHover: "#F6F7F4",
  alteredTextColor: "var(--Brand-orange-500, #FF7800)"
  // Define other light theme properties
};

export const darkTheme: Theme = {
  background: 'var(--dark-background)',
  color: 'var(--dark-text)',
  backgroundOpacity: 'var(--dark-background-opacity)',
  playerCardBackground: 'var(--Cool-Grey-cool-grey-500, #141414)',
  borderColor: 'var(--Cool-Grey-cool-grey-300, #313233)',
  playerColor: 'var(--Brand-white-500, #FFF)',
  NumberColor: 'var(--Cool-Grey-cool-grey-200, #7C8084)',
  playerDataBorder: 'var(--Cool-Grey-cool-grey-300, #313233)',
  playerDataTextColor: 'var(--Cool-Grey-cool-grey-200, #7C8084)',
  playerDataValueColor: 'var(--Brand-white-500, #FFF)',
  systemFitBackground: 'none',
  systemFitBorder: 'var(--Cool-Grey-cool-grey-300, #313233)',
  systemFitDataColor: 'var(--Brand-green-1-500, #00D1A8)',
  tabBorderColor: 'var(--Cool-Grey-cool-grey-300, #313233)',
  tabTitleColor: 'var(--Cool-Grey-cool-grey-200, #7C8084)',
  playerContentBackground: 'var(--Cool-Grey-cool-grey-400, #1B1B1B)',
  secondaryButtonBorderColor: 'var(--Cool-Grey-cool-grey-500, #141414)',
  secondaryButtonBackground: 'var(--Cool-Grey-cool-grey-300, #313233)',
  boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.50)',
  dropdownBorderColor: 'var(--Cool-Grey-cool-grey-400, #1B1B1B)',
  disciplineTextColor: 'var(--Brand-white-500, #FFF)',
  filterdropdownBackground: 'var(--Cool-Grey-cool-grey-400, #313233)',
  filterdropdownBorder: 'var(--Cool-Grey-cool-grey-400, #1B1B1B)',
  ctaIconsColor: 'var(--Brand-white-500, #FFF)',
  blurBackground: 'rgba(27, 27, 27, 0.50)',
  selectedListBackground: 'var(--Cool-Grey-cool-grey-300, #313233)',
  PitchColor: '#1B1B1B',
  injuryBarColor: "#141414",
  playerCardBorderColor: 'var(--Cool-Grey-cool-grey-200, #7C8084)',
  scrollbarTrack: '#1b1b1b',
  scrollbarThumb: 'rgba(255, 255, 255, 0.05)',
  notificationBackground: 'rgba(255, 255, 255, 0.75)',
  thumbBackground: 'var(--Cool-Grey-cool-grey-400, #1B1B1B)',
  thumbHoverBackground: 'var(--Cool-Grey-cool-grey-300, #313233)',
  notificationTextColor: 'var(--Cool-Grey-cool-grey-300, #313233)',
  notificationTitleColor: 'var(--Brand-black-500, #111)',
  playerHeaderBackground: 'rgba(20, 20, 20, 1.75)',
  chemistryPitchFill: 'rgba(17, 17, 17, 0.75)',
  clubInfoValue: 'var(--Cool-Grey-cool-grey-100, #D9D9D9)',
  searchResultsFooterBackground: 'rgba(20, 20, 20, 0.50)',
  swapOutIconBorder: "#D9D9D9",
  swapOutIconBackground: "#FFFFFF",
  swapSamePositionPlayerBorder: "#7C8084",
  newSearchBar: "#141414",
  matchLabel: "#FFFFFF",
  playerPositionLabel: "var(--Cool-Grey-cool-grey-200, #7C8084)",
  middlePitchInfoRect: "rgba(49, 50, 51, 0.75)",
  timeline: "var(--Cool-Grey-cool-grey-200, #7C8084)",
  criteriabackground: 'var(--Brand-black-500, #111)',
  emptyDataBorder: 'var(--Cool-Grey-cool-grey-500, #141414)',
  mode: "dark",
  cardShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
  imageBorderColor: '#474747',
  buttonBorderColor: 'var(--Cool-Grey-cool-grey-300, #313233)',
  tableDateColor:'var(--Brand-orange-500, #FF7800)',
  graphAreaColor:'var(--Shades-UI-Blue-blue-700, #0072A2)',
  areaLineColor:'#0072A2',
  summarybarOpenColor: '#111111',
  expanderColor : '#141414',
  shade2Chart : "#141414",
  shade1ChartHover: "#2A2A2A",
  shade2ChartHover: "#242323",
  alteredTextColor: "var(--Brand-green-1-500, #00D1A8)"
  // Define other dark theme properties
};

// Default theme based on light theme
export const defaultTheme: Theme = {
  ...lightTheme,
  // You can override specific properties if needed
};
